import { constants } from '@bedc/constants';

import { Request } from '../../../../api/whole-house/bom/search/Request';

import { SearchDataTableType } from './SearchDataTableType';

export const WoHBoMType = SearchDataTableType({
	request: Request,
	columnFields: constants.wholeHouse.bom.search.columnFields,
	filterIds: constants.wholeHouse.bom.search.filterIds,
});
